/**
 * Created by 游楷
 */
import Vue from 'vue'
import { Validator } from 'vee-validate'
// import zhCN from 'vee-validate/dist/locale/zh_CN'
import VeeValidate from 'vee-validate'
// import VueI18n from 'vue-i18n';
import zh from 'vee-validate/dist/locale/zh_CN';//引入中文文件

// 配置中文
Validator.addLocale(zh);

const config = {
    locale: 'zhCN',
    events: 'blur',
};

Vue.use(VeeValidate,config);
// 密码验证
// Validator.extend('password', {
//   messages: {
//     zhCN:field => '密码由6-16个英文字母和数字的字符串组成!'
//   },
//   validate: (value, [args]) =>{
//     const reg = /^[A-Za-z]+[0-9]+[A-Za-z0-9]*|[0-9]+[A-Za-z]+[A-Za-z0-9]*$/g;
//     return reg.test(value)
//   }
// });
// 邮箱
// Validator.extend('email', {
//   messages: {
//     zhCN: field => '邮箱不正确'
//   },
//   validate: (value, [args]) =>{
//     const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
//     return reg.test(value)
//   }
// });
// 菜单名称
Validator.extend('menuName', {
  messages: {
    zhCN:field => '菜单名称不正确'
  },
  validate: (value, [args]) =>{
    const reg = /^[^~!@#$%^&*()_+\-=\[\]【】￥……（）{}:";'<>?,.]+$/;
    return reg.test(value)
  }
});
// 机构名称
Validator.extend('mechanismName', {
  messages: {
    zhCN:field => '机构名称不正确'
  },
  validate: (value, [args]) =>{
    const reg = /^[^~!@#$%^&*()_+\-=\[\]【】￥……（）{}:";'<>?,.]+$/;
    return reg.test(value)
  }
});
// 路径
Validator.extend('ljName', {
  messages: {
    zhCN:field => '路径不正确'
  },
  validate: (value, [args]) =>{
    const reg = /^[^~!@#$%^&*()_+\-=\[\]【】￥……（）{}:";'<>?,.]+$/;
    return reg.test(value)
  }
});
// 地址验证
Validator.extend('srechAddress', {
  messages: {
    zhCN:field => '地址不正确'
  },
  validate: (value, [args]) =>{
    const reg = /^[^~!@#$%^&*_+\-=\[\]【】￥……（）{}:";'<>?,.]+$/;
    return reg.test(value)
  }
});
// // IP
// Validator.extend('ip', {
//   messages: {
//     zhCN:field => '请输入正确的IP地址!'
//   },
//   validate: (value, [args]) =>{
//     const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
//     return reg.test(value)
//   }
// });
// 端口号
// Validator.extend('port', {
//   messages: {
//     zhCN:field => '请输入正确的端口号!'
//   },
//   validate: (value, [args]) =>{
//     const reg = /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/;
//     return reg.test(value)
//   }
// });
// 验证不能为空
// Validator.extend('dataName', {
//   messages: {
//     zhCN:field => '请输入数据库名!'
//   },
//   validate: (value, [args]) =>{
//     const reg = /\S/;
//     return reg.test(value)
//   }
// });
// 人名验证
Validator.extend('personName', {
  messages: {
    zhCN: field => '请输入正确的负责人!'
  },
  validate: (value, [args]) => {
    const reg =  /^[0-9\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/
    return reg.test(value)
  }
})
// IMSI号码验证
// Validator.extend('IMSI', {
//   messages: {
//     zhCN: field => '请输入正确的IMSI号!'
//   },
//   validate: (value, [args]) => {
//     const reg = /^(01|03)(\d{2})(\w{1}(\w{1})(\d{3})(\d{6})(\w{1}))$/
//     // const reg =  /0?(13|14|15|18)[0-9]{9}/;
//     return reg.test(value)
//   }
// })
// 机构电话（座机和手机）
Validator.extend('menuPhone', {
  messages: {
    zhCN: field => '请输入正确的机构电话!'
  },
  validate: (value, [args]) => {
    // const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
    // const reg = /^((0\d{2,3}\d{7,8})|(1[35846789]\d{9}))$/
    const reg =/(^\d{3,4}-\d{7,8}$)|(^\d{6,13}$)|(^1[35846789]\d{9}$)/
    return reg.test(value)
  }
})
// 负责人电话（手机）
Validator.extend('personPhone', {
  messages: {
    zhCN: field => '请输入正确的手机!'
  },
  validate: (value, [args]) => {
    // const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/
    const reg = /^((0\d{2,3}\d{7,8})|(1[35846789]\d{9}))$/
    return reg.test(value)
  }
})
// 序号
Validator.extend('serialNumber', {
  messages: {
    zhCN: field => '请输入正确的序号!'
  },
  validate: (value, [args]) => {
    const reg = /^[+]{0,1}(\d+)$/
    return reg.test(value)
  }
})
// 输入不能为空提示
// Validator.extend('userName', {
//   messages: {
//     zhCN:field => '请输入'
//   },
//   validate: (value, [args]) =>{
//     const reg = /\S/;
//     return reg.test(value)
//   }
// });
// 下拉框不能为空
// Validator.extend('type', {
//   messages: {
//     zhCN: field => '请选择'
//   },
//   validate: (value, [args]) => {
//     const reg = /^\S+$/
//     return reg.test(value)
//   }
// })
// 设备名称开头英文和汉字
// Validator.extend('Sname', {
//   messages: {
//     zhCN: field => '设备名称需以英文或者中文开头'
//   },
//   validate: (value, [args]) => {
//     // const reg = /^[a-zA-Z\u4e00-\u9fa5][a-zA-Z0-9\u4e00-\u9fa5]*$/
//     const reg = /^[a-zA-Z\u4e00-\u9fa5]\S+$/
//     return reg.test(value)
//   }
// })
// 经纬度
// Validator.extend('long', {
//   messages: {
//     zhCN: field => '经纬度格式错误'
//   },
//   validate: (value, [args]) => {
//     // const reg = /^[a-zA-Z\u4e00-\u9fa5][a-zA-Z0-9\u4e00-\u9fa5]*$/
//     const reg = /^([+-]?)\d*\.?\d+$/
//     return reg.test(value)
//   }
// })
// 数值验证
// Validator.extend('count', {
//   messages: {
//     zhCN: field => '请输入正整数字值'
//   },
//   validate: (value, [args]) => {
//     const reg = /^[1-9]\d*$/
//     return reg.test(value)
//   }
// })
// 密码
// Validator.extend('passwordOld', {
//   messages: {
//     zhCN:field => '密码由6-16个英文字母和数字的字符串组成!'
//   },
//   validate: (value, [args]) =>{
//     const reg = /^[A-Za-z]+[0-9]+[A-Za-z0-9]*|[0-9]+[A-Za-z]+[A-Za-z0-9]*$/g;
//     return reg.test(value)
//   }
// });
// 密码二次验证
// Validator.extend('passwordAgain', {
//   messages: {
//     zhCN:function (field,succes) {
//       return  '必须和新密码相同'
//
//     }
//   },
//   validate: (value, [args]) =>{
//     let jude=false
//     const reg = /^[A-Za-z]+[0-9]+[A-Za-z0-9]*|[0-9]+[A-Za-z]+[A-Za-z0-9]*$/g;
//     if(reg.test(value)&&value===args){
//       jude=true
//     }
//     return jude
//   }
// });

const dictionary = {
  zhCN: {
    messages: {
      required: (field) => "请输入" + field,
    },
    attributes: {
      menuName: '菜单名称',
        mechanismName:'机构名称',
        personName:'人名',
        menuPhone: '机构电话', //
        personPhone: '负责人电话',
        srechAddress: '正确地址',
        serialNumber: '序号',
        ljName:"路径",
      // password:'新密码',
      // passwordAgain:'再次确认密码',
      // passwordOld:'原始密码',
      // port:'端口',
      // // ip:'IP', //
      // dataName:'数据库名',
      // userName:'用户名', //
      // // email: '邮箱', //
      // clearDateNum: '清理时间', //

      // spaceWarning: '设定清理内存', //
      // type: '类型',
      // count: '申请数量',
      // lq_fwq_name: '服务器名称',
      // description: '描述',
      // selectName: '设备类型', //
      // Sname: '设备名称', //
      // longitude: '经度', //
      // latitude: '纬度', //
      // passWord: '口令', //
      // countID: '设备ID' //
    }
  }
};
Validator.updateDictionary(dictionary);


Vue.use(VeeValidate, {
  locale: 'zhCN',
});



// WEBPACK FOOTER //
// ./src/CValidation/YValidation.js